import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Gamepad2, 
  Brain, 
  Timer, 
  MessageSquare, 
  Edit3, 
  Trophy,
  Sparkles,
  ChevronRight
} from 'lucide-react';
import Layout from '../components/layout/Layout';
import { cn } from '../lib/utils';

const games = [
  {
    id: 'memory',
    title: 'Jogo da Memória',
    description: 'Encontre os pares de palavras em inglês e português',
    icon: Brain,
    color: 'primary',
    path: '/games/memory',
    xpReward: '50-150 XP',
  },
  {
    id: 'speed-quiz',
    title: 'Quiz Rápido',
    description: 'Responda perguntas contra o tempo',
    icon: Timer,
    color: 'accent',
    path: '/games/speed-quiz',
    xpReward: '40-120 XP',
  },
  {
    id: 'ai-chat',
    title: 'Chat com IA',
    description: 'Pratique conversação com um tutor de IA',
    icon: MessageSquare,
    color: 'success',
    path: '/chat',
    xpReward: 'Prática livre',
  },
  {
    id: 'writing',
    title: 'Exercícios de Escrita',
    description: 'Escreva textos e receba correções',
    icon: Edit3,
    color: 'warning',
    path: '/writing',
    xpReward: '30-100 XP',
  },
];

const GamesPage = () => {
  const navigate = useNavigate();

  return (
    <Layout showBack title="Jogos e Atividades">
      <div className="px-4 py-6 space-y-6">
        {/* Header */}
        <div className="text-center space-y-2">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-primary to-accent flex items-center justify-center mx-auto">
            <Gamepad2 className="w-8 h-8 text-primary-foreground" />
          </div>
          <h1 className="font-display text-2xl font-bold">Jogos e Atividades</h1>
          <p className="text-muted-foreground">
            Aprenda inglês de forma divertida
          </p>
        </div>

        {/* Games Grid */}
        <div className="space-y-3">
          {games.map((game) => {
            const Icon = game.icon;
            const colorClasses = {
              primary: 'bg-primary/10 text-primary',
              accent: 'bg-accent/10 text-accent',
              success: 'bg-success/10 text-success',
              warning: 'bg-warning/10 text-warning',
            };

            return (
              <button
                key={game.id}
                onClick={() => navigate(game.path)}
                className="card-elevated w-full p-4 text-left group"
              >
                <div className="flex items-center gap-4">
                  <div className={cn(
                    'w-14 h-14 rounded-xl flex items-center justify-center shrink-0 transition-transform group-hover:scale-110',
                    colorClasses[game.color]
                  )}>
                    <Icon className="w-7 h-7" />
                  </div>
                  
                  <div className="flex-1 min-w-0">
                    <h3 className="font-semibold">{game.title}</h3>
                    <p className="text-sm text-muted-foreground line-clamp-1">
                      {game.description}
                    </p>
                    <div className="flex items-center gap-1 mt-1">
                      <Sparkles className="w-3 h-3 text-primary" />
                      <span className="text-xs text-primary font-medium">{game.xpReward}</span>
                    </div>
                  </div>

                  <ChevronRight className="w-5 h-5 text-muted-foreground group-hover:translate-x-1 transition-transform" />
                </div>
              </button>
            );
          })}
        </div>

        {/* Leaderboard Link */}
        <button
          onClick={() => navigate('/leaderboard')}
          className="w-full p-4 rounded-xl bg-gradient-to-r from-primary/10 to-accent/10 border border-primary/20 flex items-center justify-between group"
        >
          <div className="flex items-center gap-3">
            <Trophy className="w-6 h-6 text-primary" />
            <div className="text-left">
              <p className="font-semibold">Ver Ranking</p>
              <p className="text-sm text-muted-foreground">Compete com outros estudantes</p>
            </div>
          </div>
          <ChevronRight className="w-5 h-5 text-primary group-hover:translate-x-1 transition-transform" />
        </button>

        {/* Daily Challenge Info */}
        <div className="p-4 rounded-xl bg-muted/50 text-center">
          <p className="text-sm text-muted-foreground">
            🎮 Complete jogos para ganhar XP extra e subir no ranking!
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default GamesPage;
